// i18n area 'auth' — locale es-ES (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/auth.es-ES.meta.json.
import type { enUS } from './auth'

export const esES: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Acceda a su cuenta',
    username: 'Nombre de usuario',
    usernamePlaceholder: 'Introduzca el nombre de usuario',
    usernameHint: 'Use usuario@dominio para autenticarse en un realm de directorio',
    continue: 'Continuar',
    changeUser: '¿No es usted?',
    password: 'Contraseña',
    forgotPassword: '¿Contraseña olvidada?',
    submit: 'Acceder',
    otp: 'Código de un solo uso',
    otpSubtitle: 'Introduzca el código de su autenticador',
    otpHint: 'Seis cifras de la app de autenticación, o uno de los códigos de recuperación',
    otpSubmit: 'Verificar',
    invalidCredentials: 'Nombre de usuario o contraseña no válidos',
    tooManyAttempts: 'Demasiados intentos — espere un momento y vuelva a intentarlo',
    realmUnavailable: 'El realm no puede verificar las credenciales en este momento — el store del clúster no está accesible. Acceda como usuario local (break-glass).',
    genericError: 'Acceso fallido — ¿está accesible el backend TVirt?'
  },
  user: {
    logout: 'Salir',
    password: {
      menu: 'Cambiar contraseña',
      title: 'Cambie su contraseña',
      current: 'Contraseña actual',
      new: 'Nueva contraseña',
      confirm: 'Confirmar nueva contraseña',
      mismatch: 'Las contraseñas no coinciden',
      error: 'No se pudo cambiar la contraseña',
      forcedTitle: 'Cambie la contraseña para continuar',
      forcedHint: 'Esta contraseña la estableció un administrador y debe sustituirse antes de entrar.',
      forcedSubmit: 'Cambiar y entrar'
    },
    mfa: {
      title: 'Autenticación de dos factores',
      subtitle: 'Un segundo factor solicitado en cada acceso',
      loadError: 'No se pudo cargar el estado del segundo factor',
      enrolled: 'Activo',
      notEnrolled: 'No activo',
      enrolledAt: 'Activado el',
      codesRemaining: 'Códigos de recuperación restantes',
      requiredHint: 'Un administrador exige el segundo factor en esta cuenta: configúrelo ahora — hasta que lo haga puede acceder, pero poco más.',
      enroll: 'Configurar',
      enrollTitle: 'Configurar la autenticación de dos factores',
      enrollHint: 'Escanee este código con la app de autenticación y luego teclee el código que muestra para confirmar.',
      secretHint: '¿No puede escanearlo? Teclee este secreto en la app:',
      code: 'Código de la app',
      confirm: 'Confirmar',
      startError: 'No se pudo iniciar la configuración',
      confirmError: 'No se pudo confirmar la configuración',
      codesTitle: 'Sus códigos de recuperación',
      codesWarning: 'Estos códigos se muestran una sola vez. Guárdelos ahora: cada uno permite acceder cuando el autenticador no está disponible, y vale una sola vez.',
      codesAck: 'He guardado los códigos de recuperación',
      codesDone: 'Hecho',
      copy: 'Copiar',
      copied: 'Copiado',
      download: 'Descargar',
      regenerate: 'Nuevos códigos de recuperación',
      regenerateTitle: 'Regenerar los códigos de recuperación',
      regenerateHint: 'Todos los códigos emitidos hasta ahora dejan de funcionar en el momento en que se genera el nuevo juego.',
      regenerateConfirm: 'Regenerar',
      regenerateError: 'No se pudieron regenerar los códigos de recuperación',
      remove: 'Quitar',
      removeTitle: 'Quitar el segundo factor',
      removeConfirm: 'Quitar',
      removeHint: 'La cuenta vuelve a solo contraseña. Puede reconfigurar el segundo factor cuando quiera.',
      removeRequiredHint: 'Un administrador exige el segundo factor en esta cuenta, así que el servidor rechazará quitarlo — pida antes que retiren la obligación.',
      removeError: 'No se pudo quitar el segundo factor'
    },
    profile: {
      menu: 'Ir a mi perfil',
      sessions: 'Sesiones activas',
      sessionsHint: 'Sus sesiones abiertas en este nodo',
      sessionsEmpty: 'Ninguna sesión activa',
      sessionCreated: 'Sesión iniciada',
      sessionExpires: 'Caduca',
      revoke: 'Revocar sesión',
      revokeError: 'No se pudo revocar la sesión',
      loadError: 'No se pudieron cargar las sesiones'
    }
  }
}
